import { render, staticRenderFns } from "./tooltipDataAside.vue?vue&type=template&id=6c30867a&scoped=true&"
import script from "./tooltipDataAside.vue?vue&type=script&lang=js&"
export * from "./tooltipDataAside.vue?vue&type=script&lang=js&"
import style0 from "./tooltipDataAside.vue?vue&type=style&index=0&id=6c30867a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30867a",
  null
  
)

export default component.exports